import { AppDialog, FormField, SelectField } from "@/components/common";
import { Button } from "@/components/ui/button";
import {
  useESGDisclosureSelectionStore,
  useESGReportWorkflowStore,
} from "@/features/esg/hooks/useESGReportStore";
import { CustomDisclosureSchema } from "@/features/esg/schemas/esg.schema";
import { useTran } from "@/hooks";
import { Form, Formik } from "formik";
import { observer } from "mobx-react-lite";
import { useRef } from "react";

const CustomDisclosureDialog = observer(() => {
  const { t } = useTran();
  const formikRef = useRef();
  const { addCustomDisclosure } = useESGDisclosureSelectionStore();

  const { showCustomDisclosureDialog, setShowCustomDisclosureDialog } =
    useESGReportWorkflowStore();

  const categoryOptions = [
    { key: "Environment", value: "Environment" },
    { key: "Social", value: "Social" },
    { key: "Governance", value: "Governance" },
  ];

  const handleAdd = (values) => {
    addCustomDisclosure(values);
    setShowCustomDisclosureDialog(false);
  };

  return (
    <AppDialog
      open={showCustomDisclosureDialog}
      onOpenChange={(openState) => {
        if (!openState) setShowCustomDisclosureDialog(false);
      }}
      title={t("Add Custom Disclosure")}
      footer={
        <div className="flex gap-x-2 items-center justify-end">
          <Button
            variant="outline"
            onClick={() => setShowCustomDisclosureDialog(false)}
          >
            {t("Cancel")}
          </Button>
          <Button onClick={() => formikRef.current.submitForm()}>
            {t("Add")}
          </Button>
        </div>
      }
    >
      <Formik
        initialValues={{ category: "Environment", code: "", title: "" }}
        innerRef={formikRef}
        validationSchema={CustomDisclosureSchema}
        onSubmit={handleAdd}
      >
        {({ errors, touched, values, handleChange }) => (
          <Form className="space-y-3">
            <SelectField
              id="category"
              label={t("Category")}
              options={categoryOptions}
              value={values.category}
              onChange={handleChange}
              error={touched.category && errors.category}
              required
            />
            <FormField
              name="code"
              label={t("Code")}
              placeholder={t("e.g., CUSTOM-1")}
              value={values.code}
              onChange={handleChange}
              error={touched.code && errors.code}
              required
            />
            <FormField
              name="title"
              label={t("Title")}
              placeholder={t("Disclosure title")}
              value={values.title}
              onChange={handleChange}
              error={touched.title && errors.title}
              required
            />
          </Form>
        )}
      </Formik>
    </AppDialog>
  );
});

export default CustomDisclosureDialog;
